<div class="flex flex-col items-center space-y-4">
    <h2 class="text-lg font-bold text-white">Formation</h2>
    <div class="text-gray-400 text-sm">
        {{ match?.lineup.formation || '' }}
    </div>

    <div class="flex space-x-4">
        <button class="px-4 py-1 rounded-full font-semibold text-sm" [ngClass]="{
        'bg-primary text-black': selectedTeam === 'team1',
        'text-white': selectedTeam !== 'team1'
      }" (click)="switchTeam('team1')">
            {{ match?.teams?.team1?.name || 'Équipe A' }}
        </button>
        <!-- <button class="px-4 py-1 rounded-full font-semibold text-sm" [ngClass]="{
            'bg-primary text-black': selectedTeam === 'team2',
            'text-white': selectedTeam !== 'team2'
          }" (click)="switchTeam('team2')">
          {{ match?.teams?.team2?.name || 'Équipe B' }}
        </button> -->
    </div>

    <!-- CENTRAGE GLOBAL DU TERRAIN -->
    <div class="flex justify-center items-center w-full">
        <div class="relative overflow-visible rounded-lg w-[358px] h-[600px] md:w-[644px] md:h-[495px] bg-green-800">
            <!-- Image terrain desktop -->
            <img [src]="fieldImage()" class="hidden md:block w-full h-full object-cover" alt="Terrain de football" />
            <!-- Image terrain mobile -->
            <img [src]="fieldImageMobile()" class="block md:hidden w-full h-full object-cover" alt="Terrain de football" />

            <!-- LINEUP -->
            <ng-container *ngIf="match?.lineup?.starting_players?.length > 0;">

                <div class="absolute inset-0">
                    <ng-container *ngFor="let player of positionedPlayers">
                        <div class="absolute flex flex-col items-center" [ngStyle]="{ top: player.top, left: player.left }"
                             (click)="selectPlayer(player)">
                            <!-- AVATAR ROND DU JOUEUR -->
                            <div class="relative w-12 h-12">
                                <!-- Carton visuel -->
                                <div *ngIf="!readOnlyMode && getCardType(player.id) !== 'none'"
                                     class="absolute -top-1 -right-1 w-3.5 h-5 rounded-sm shadow-sm" [ngClass]="{
    'bg-yellow-400': getCardType(player.id) === 'yellow',
    'bg-red-600': getCardType(player.id) === 'red'
  }"></div>

                                <!-- ⚽ Ballon visuel -->
                                <div *ngIf="!readOnlyMode && getGoalCount(player.id) > 0"
                                     class="absolute -bottom-1 -right-1 text-white text-[16px] drop-shadow">
                                    ⚽
                                    <span *ngIf="getGoalCount(player.id) > 1"
                                          class="absolute -top-0.5 -right-2 z-10 text-[12px] font-bold bg-black/60 rounded-full text-white   px-1 leading-none">
                    {{ getGoalCount(player.id) }}
                  </span>
                                </div>
                                <!-- ROND du joueur -->
                                <div
                                    class="w-full h-full rounded-full border-2 border-black flex items-center justify-center font-bold text-black hover:scale-105 transition-transform bg-white">
                                    {{ getInitials(player) || '?' }}
                                </div>
                            </div>

                            <!-- Nom -->
                            <div
                                class="text-sm mt-1 bg-black/80 text-white px-2 py-0.5 rounded text-center max-w-[100px] break-words">
                                {{ player?.firstName || 'Joueur' }}
                            </div>
                        </div>

                    </ng-container>
                </div>
            </ng-container>

            <!-- FALLBACK si pas de lineup -->
            <!-- <ng-template #fallbackView>
              <div class="absolute inset-0 grid grid-cols-3 gap-4 px-4 py-6">
                <ng-container *ngIf="players.length > 0; else noPlayers">
                  <ng-container *ngFor="let player of players; let i = index">
                    <div class="flex flex-col items-center justify-center" [style.gridColumn]="(i % 3) + 1"
                      [style.gridRow]="Math.floor(i / 3) + 1">
                      <div
                        class="w-12 h-12 rounded-full bg-yellow-400 border-2 border-black flex items-center justify-center font-bold text-black hover:scale-105 transition-transform">
                        {{ getInitials(player) || '10' }}
                      </div>
                      <div
                        class="text-sm mt-1 bg-black/80 text-white px-2 py-0.5 rounded text-center max-w-[100px] break-words">
                        {{ (player?.firstName || 'Joueur') }}
                      </div>
                    </div>
                  </ng-container>
                </ng-container>


              </div>
            </ng-template> -->
            <ng-template #noPlayers>
                <div class="text-center text-gray-400 italic py-6 w-full col-span-3">
                    Pas encore de joueurs à afficher.
                </div>
            </ng-template>
        </div>
    </div>


    <div class="flex flex-col md:flex-row md:justify-center gap-4 mt-6 w-full">

        <!-- COLONNE DROITE : INFOS DU JOUEUR SÉLECTIONNÉ -->
        <div class="col-span-1 bg-black/90 text-white p-4 rounded-lg" *ngIf="!readOnlyMode && selectedPlayer()">
            <h3 class="text-xl font-bold mb-2">
                {{ selectedPlayer().firstName }} {{ selectedPlayer().lastName }}
            </h3>


            <div class="mt-2 space-y-1" *ngIf="selectedPlayer()">
                <p *ngIf="getGoalCount(selectedPlayer().id) > 0" class="text-green-400">
                    ⚽ A marqué {{ getGoalCount(selectedPlayer().id) }} but{{ getGoalCount(selectedPlayer().id) > 1 ? 's' : '' }}
                </p>
                <p *ngIf="getYellowCardCount(selectedPlayer().id) === 1" class="text-yellow-300">
                    🟨 Carton jaune
                </p>
                <p *ngIf="getYellowCardCount(selectedPlayer().id) >= 2" class="text-yellow-300">
                    🟨🟨 Deux cartons jaunes
                </p>
                <p *ngIf="hasRedCard(selectedPlayer().id)" class="text-red-400">🟥 Carton rouge</p>
            </div>



            <button class="mt-4 px-4 py-1 bg-white text-black rounded" (click)="selectedPlayer.set(null)">Fermer</button>
        </div>
        <!-- COLONNE GAUCHE : REMPLAÇANTS -->
        <div *ngIf="!readOnlyMode" class="col-span-1 bg-black/70 rounded-lg p-4 text-white">
            <h3 class="text-lg font-bold mb-2">Remplaçants</h3>
            <ng-container *ngIf="substitutePlayers().length > 0; else noSub">
                <div *ngFor="let sub of substitutePlayers()" class="flex items-center space-x-3 mb-3">
                    <div class="w-10 h-10 rounded-full bg-yellow-400 text-black flex items-center justify-center font-bold">
                        {{ getInitials(sub) }}
                    </div>
                    <span>
            {{ sub.firstName }} {{ sub.lastName }}
                        <!-- <span *ngIf="hasRedCard(sub.id)" class="text-red-400 ml-1">🟥</span>
               <span *ngIf="!hasRedCard(sub.id) && getYellowCardCount(sub.id) === 1" class="text-yellow-300 ml-1">🟨</span>
              <span *ngIf="!hasRedCard(sub.id) && getYellowCardCount(sub.id) >= 2" class="text-yellow-300 ml-1">🟨🟨</span> -->
          </span>
                </div>
            </ng-container>
            <ng-template #noSub>
                <p class="text-sm italic text-gray-300">Aucun remplaçant enregistré</p>
            </ng-template>
        </div>

        <!-- COLONNE CENTRALE : VIDE -->
        <div class="col-span-1"></div>
        <!-- COLONNE SÉPARÉE : EXPULSÉS -->
        <div *ngIf="getRedCardedPlayers().length > 0" class="col-span-1 bg-black/70 rounded-lg p-4 text-white">
            <h3 class="text-lg font-bold mb-2">Expulsés</h3>
            <ng-container *ngIf="getRedCardedPlayers().length > 0; else noRed">
                <div *ngFor="let player of getRedCardedPlayers()" class="flex items-center space-x-3 mb-3">
                    <div class="w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center font-bold">
                        {{ getInitials(player) }}
                    </div>
                    <div>
                        <div>{{ player.firstName }} {{ player.lastName }}</div>
                        <div class="text-sm mt-0.5">
                            <ng-container [ngSwitch]="getExpulsionType(player.id)">
                                <span *ngSwitchCase="'red_card'" class="text-red-400">🟥 Rouge direct</span>
                                <span *ngSwitchCase="'two_yellow_cards'" class="text-yellow-300">🟨🟨 Deux jaunes</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- <ng-template #noRed>
              <p class="text-sm italic text-gray-300">Aucun joueur expulsé</p>
            </ng-template> -->
        </div>


    </div>


</div>
